import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import "./SmartOptionsOneStopSolution.css";
import Slider from "react-slick";
import Slider1 from "./OneStopSolutionscreen1.png";
import Slider2 from "./OneStopSolutionscreen2.png";
import Slider3 from "./OneStopSolutionscreen3.png";
import Slider4 from "./OneStopSolutionscreen4.png";
const data = [
  { id: 1, imgName: Slider1 },
  { id: 2, imgName: Slider2 },
  { id: 3, imgName: Slider3 },
  { id: 4, imgName: Slider4 },
  { id: 5, imgName: Slider1 },
]

function SmartOptionsOneStopSolution() {
  const settings = {
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: false,
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <>
      <section class="SmartOptionsOneStopSolution_section">
        <div class="container">
          <div class="section-heading center">One Stop Solution for Option <span>Trader & Scalper</span></div>
          <div className="SmartOptionsOneStopSolution_slider">
            <Slider {...settings}>
              {data.map((crntvalue, index) => {
                return (
                  <div className="SmartOptionsOneStopSolution_slideritem">
                    <img src={crntvalue.imgName} alt={crntvalue.imgName + crntvalue.imgName} className="img-fluid"></img>
                  </div>
                )
              })
              }
            </Slider>
          </div>
        </div>
      </section>
    </>
  );
}
export default SmartOptionsOneStopSolution;
